import brand from '@helpers/brand';
import { cssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(m.section) `
  position: absolute;
  top: 100%;
  left: 0;
  display: grid;
  background: ${cssVar('bgColor')};
  grid-template-columns: 1fr 1fr;
  min-height: 560px;
  width: 100%;
`;
const ColumnLeft = styled.div `
  position: relative;
  display: grid;
`;
const Image = styled(m.img) `
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  grid-column: 1;
  grid-row: 1;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  width: 100%;
`;
const ColumnRight = styled.div `
  --line-size: 32px;
  --padding-size: 48px;
  --offset-amount: calc(var(--padding-size) - var(--line-size));

  display: block;
  padding: 24px 24px 24px 48px;

  @media ${from(Device.TabletLarge)} {
    --line-size: 140px;
    --padding-size: 168px;

    padding: 36px 36px 36px 168px;
  }
`;
const Title = styled.h2 `
  display: block;
  ${fonts.crimsonText.regular};
  font-size: 42px;
  line-height: 54px;
  margin: 0 0 24px;
`;
const TitleLink = styled.a `
  position: relative;
  color: currentColor;
  text-decoration: none;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    right: 100%;
    height: 1px;
    background: ${brand.gold};
    transform: translateY(-50%) translateX(calc(var(--offset-amount) * -1)) scaleX(0);
    transform-origin: right center;
    transition: transform 0.3s ease-out;
    width: var(--line-size);
  }

  &:focus,
  &:hover {
    outline: none;
    text-decoration: none;

    &::before {
      transform: translateY(-50%) translateX(calc(var(--offset-amount) * -1)) scaleX(1);
    }
  }
`;
const List = styled.ul `
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;
const Item = styled.li `
  display: block;
  margin: 0 0 16px;
`;
const Link = styled.a `
  position: relative;
  display: block;
  color: ${cssVar('fgColor')};
  ${fonts.crimsonText.regular};
  font-size: 22px;
  line-height: 28px;
  text-decoration: none;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    right: 100%;
    height: 1px;
    background: ${brand.gold};
    transform: translateY(-50%) translateX(calc(var(--offset-amount) * -1)) scaleX(0);
    transform-origin: right center;
    transition: transform 0.3s ease-out;
    width: var(--line-size);
  }

  &:focus,
  &:hover {
    outline: none;
    text-decoration: none;

    &::before {
      transform: translateY(-50%) translateX(calc(var(--offset-amount) * -1)) scaleX(1);
    }
  }

  @media ${from(Device.TabletLarge)} {
  }
`;
export default {
    ColumnLeft,
    ColumnRight,
    Container,
    Image,
    Item,
    Link,
    List,
    Title,
    TitleLink,
};
